IntlMessageFormat.__addLocaleData({"locale":"aa","pluralRuleFunction":function (n,ord){if(ord)return"other";return"other"}});
IntlMessageFormat.__addLocaleData({"locale":"aa-DJ","parentLocale":"aa"});
IntlMessageFormat.__addLocaleData({"locale":"aa-ER","parentLocale":"aa"});
IntlMessageFormat.__addLocaleData({"locale":"aa-ET","parentLocale":"aa"});
